import React, { useState, useEffect } from "react";
import { Button, Icon } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import * as conf from "../../config/config";
import axios from "axios";

const PdfPreview = ({ url, onClose, nombre }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  useEffect(() => {
    axios.get(url, {
      responseType: "blob",
      headers: { Authorization: "Bearer " + sessionStorage.getItem("tok") }
    }).then((res) => {
      setBlobUrl(window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })));
    });
    return () => { if (blobUrl) window.URL.revokeObjectURL(blobUrl); };
  }, [url]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong>{nombre}</strong>
        <Button size="sm" color="secondary" onClick={onClose}>Cerrar vista previa</Button>
      </div>
      {blobUrl ? (
        <iframe src={blobUrl} style={{ width: "100%", height: "500px", border: "1px solid #ddd" }} title="Vista previa PDF" />
      ) : (
        <p>Cargando...</p>
      )}
    </div>
  );
};

const SubirPdf = ({ idMovimiento }) => {
  const [archivos, setArchivos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    cargarArchivos();
  }, []);

  const cargarArchivos = () => {
    Crud_Catalogos(
      `movimientos-facturar/pdf/${idMovimiento}/list`,
      "pdf", "get", "", [], "", "", "", []
    ).then((res) => {
      setArchivos(res || []);
    });
  };

  const subirArchivo = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    axios.post(
      conf.api_raiz + `movimientos-facturar/pdf/${idMovimiento}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data", Authorization: "Bearer " + sessionStorage.getItem("tok") } }
    ).then(() => {
      setUploading(false);
      cargarArchivos();
    }).catch(() => setUploading(false));
  };

  const getPdfUrl = (archivo) => {
    return conf.api_raiz + `movimientos-facturar/pdf/${idMovimiento}/${archivo}`;
  };

  const descargar = (archivo) => {
    axios.get(getPdfUrl(archivo), {
      responseType: "blob",
      headers: { Authorization: "Bearer " + sessionStorage.getItem("tok") }
    }).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", archivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      <h5>Archivos PDF - Movimiento {idMovimiento}</h5>
      <div className="mb-3">
        <input type="file" accept=".pdf" onChange={subirArchivo} disabled={uploading} />
        {uploading && <span className="ml-2">Subiendo...</span>}
      </div>

      {archivos.length > 0 ? (
        <ul className="list-group mb-3">
          {archivos.map((archivo, i) => (
            <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
              <span><Icon name="file-text" className="mr-2" />{archivo}</span>
              <div>
                <Button size="sm" color="info" className="mr-2" onClick={() => setPreview(archivo)}>
                  <Icon name="eye" /> Ver
                </Button>
                <a href="#" onClick={(e) => { e.preventDefault(); descargar(archivo); }} className="btn btn-sm btn-success">
                  <Icon name="download" /> Descargar
                </a>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-muted">No hay archivos subidos</p>
      )}

      {preview && (
        <PdfPreview url={getPdfUrl(preview)} onClose={() => setPreview(null)} nombre={preview} />
      )}
    </div>
  );
};

export default SubirPdf;
